import { Serializer } from '@/services/serializer';

export default {
    install (Vue) {
        const serializer = new Serializer();        
        Vue.serializer = serializer;

        Object.defineProperties(Vue.prototype, {
            serializer: {
                get() { return serializer; }
            },
            $serializer: {
                get() { return serializer; }
            },
        });
    }
};
